export const routeHelper = {
    forecastNow: '/weather-forecast/now/',
    maps: '/maps/',
    airQuality: '/air-quality/',
    terms: '/legal/terms',
    privacy: '/legal/privacy',
    partners: '/partners',
    sitemap: '/sitemap/',
    usaSitemap: '/sitemap/North-America/United-States/states',
    adChoices: '/legal/privacy#digitaladvertisingandyourchoices',
    faq: '/faq'
};

export const weatherBugAdsForAdvertisersRoute = 'https://ads.weatherbug.com/';